import type { ChatTypes } from 'devextreme-react/chat';

export const AzureOpenAIConfig = {
    dangerouslyAllowBrowser: true,
    deployment: '',
    apiVersion: '',
    endpoint: '',
    apiKey: '',
};

export const CHAT_DISABLED_CLASS = 'chat-disabled';
export const CHAT_LOADING_CLASS = 'chat-loading';
export const ALERT_TIMEOUT = 1000 * 60;

export const user: ChatTypes.User = {
    id: 'user',
};

export const assistant: ChatTypes.User = {
    id: 'assistant',
    name: 'Virtual Assistant',
};
